<div class="activity-stream-multiple-items-container">
  <coin-v2-button
    [type]="'secondary'"
    [icon]="'expand_more'"
    [text]="'activity-stream.show-btn' | translate"
    (click)="onShowClicked($event)"></coin-v2-button>

  @if (showDetails()) {
    <div
      class="changed-properties mat-elevation-z2"
      animate.enter="fade-in"
      animate.leave="fade-out">
      @for (item of filteredItems(); track item) {
        <div
          class="changed-property"
          [class.no-changes]="item.originalValue === item.currentValue">
          <ng-container
            [ngTemplateOutlet]="isEmployeeChange(item) ? employeeChange : textChange"
            [ngTemplateOutletContext]="{ item }" />
        </div>
      }
    </div>
  }
</div>

<ng-template
  #textChange
  let-item="item">
  <div class="left">
    <p>
      {{
        isDisplayedUnformatted(item)
          ? item?.originalValue
          : ((item?.originalValue | translate | formatUnknownValue) ?? '-')
      }}
    </p>
    <mat-icon>keyboard_arrow_right</mat-icon>
  </div>
  <div class="right">
    <p>{{ item.propertyName | enumToText }}:</p>
    <p class="bold">
      {{
        isDisplayedUnformatted(item) ? item?.currentValue : (item?.currentValue | translate | formatUnknownValue) || '-'
      }}
    </p>
  </div>
</ng-template>

<ng-template
  #employeeChange
  let-item="item">
  <div class="left">
    @if (item?.originalValue) {
      <coin-siemens-energy-employee-preview
        [employee]="item?.originalValue | employeeId$ | async"
        [showGid]="true"></coin-siemens-energy-employee-preview>
    }
    @if (!item?.originalValue) {
      <p>-</p>
    }
    <mat-icon>keyboard_arrow_right</mat-icon>
  </div>
  <div class="right">
    <p>{{ nameEmployeeProperty(item?.propertyName) | enumToText }}:</p>
    @if (item?.currentValue) {
      <coin-siemens-energy-employee-preview
        [employee]="item?.currentValue | employeeId$ | async"
        [showGid]="true"></coin-siemens-energy-employee-preview>
    }
    @if (!item?.currentValue) {
      <p>-</p>
    }
  </div>
</ng-template>
